module.exports = __webpack_public_path__ + "static/img/payment1.8bb2790e.png";